import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CustomLayout from "./CustomLayout";
import _ from "lodash";
import { useCustomOperate } from "@/hooks";
import { useRightsDict, useUserInfo } from "@/hooks/user";

type Props = {
  children: ReactNode;
}

export default function Global({ children }: Props) {
  // 当前路径
  const { pathname } = useLocation();
  // 排除路由
  const excludeRouters = ['/login'];
  // 自定义操作
  const { customReplace } = useCustomOperate();
  // 用户信息
  const { userInfo, refresh } = useUserInfo();
  // 权益字典
  const { rightsDict, getRightsDict } = useRightsDict();

  // 处理鉴权
  const handleAuth = () => {
    // token
    const token = localStorage.token;
    // 处理重定向
    pathname !== '/login' && !token ? customReplace('/login') : (() => {
      !userInfo && refresh();
      rightsDict.length === 0 && getRightsDict();
    })();
  };

  // 监听
  useEffect(() => {
    handleAuth();
  }, [pathname]);

  return (
    <div className="">
      {
        _.includes(excludeRouters, pathname) ? <div className="">
          {children}
        </div> : <CustomLayout>
          {children}
        </CustomLayout>
      }
    </div>
  );
}
